export default __webpack_public_path__ + "static/media/dbclick-share.8209ad3b.png";